<script setup lang="ts">
import {Textarea} from "@/Components/Library";
import {AudioRecorder} from "@/Components/Global";
import {useTemplateRef} from "vue";

const {question, disabled = false} = defineProps<{
    question: {[key: string]: any};
    disabled?: boolean;
}>();
const model = defineModel();
const audioRecorder = useTemplateRef("audioRecorder");

defineExpose({
    stopRecording: () => audioRecorder.value?.stopRecording(),
    saveRecording: () => audioRecorder.value?.saveRecording(),
    deleteRecording: () => audioRecorder.value?.deleteRecording(),
});
</script>
<template>
    <div>
        <h3 class="mb-1 mt-1 text-sm font-bold">Type your response</h3>
        <p v-if="question.param('allow_annotations')" class="mb-1 text-sm">
            To anchor this comment to a place in the document long press or click and hold.
        </p>
        <Textarea
            v-model="model.content"
            placeholder="Type your response here..."
            class="w-full"
            autoResize
            rows="2"
            :disabled
        />
        <AudioRecorder v-if="question.params.allow_voice_responses" ref="audioRecorder" v-model="model.audio" />
    </div>
</template>
